import { useCallback, useState } from "react";

// Factor out async action execution state.
// Similar to a very simple useMutation(), but takes the action to
// run as an argument.
// Maybe there's a better place for this?
export const useAction = () => {
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<unknown>(null);

  const action = useCallback(async (body: () => Promise<void>) => {
    setPending(true);
    setError(null);
    try {
      await body();
    } catch (err) {
      setError(err);
    } finally {
      setPending(false);
    }
  }, []);

  return [action, pending, error] as const;
};
